import React from "react";
import { TbGalaxy } from "react-icons/tb";

const LoadingDB = () => {
    return (
        <div className="loading_db_cont">
            <div className="sidebar_loading_db_cont fade-in">

            </div>
            <div className="body_loading_db_cont fade-in">
                <div className="loading_logo_erioon">
                    <p className="loading_logo_erioon_icon"><i><TbGalaxy /></i></p>
                </div>
            </div>

        </div>
    )
}

export default LoadingDB